/**
 * ./src/exercise1/Exercise1Video.js
 * 
 * This module displays a **video tutorial** for **Exercise 1** to 
 * guide users on how to properly follow the breathing patterns before starting the workout.
 * 
 */


import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Exercise1Video.css'; // You can create this for custom video styling
import E1Video from './E1Video.mp4';

const Exercise1Video = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // This will go back to the previous page in history
  };

  return (
    <div className="video-page-container">
      <video width="60%" controls className="guidance-video">
        <source src={E1Video} type="video/mp4" /> 
        Your browser does not support the video tag.
      </video>
      <button className="back-button" onClick={handleBackClick}>
        Back
      </button>
    </div>
  );
};

export default Exercise1Video;
